import { Drawer } from "antd";
import type { DrawerProps } from "antd";

export type UIDrawerProps = DrawerProps;

export const UIDrawer = (props: UIDrawerProps) => <Drawer {...props} />;
